/**
 * The entry point for the options page.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/antd.scss";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { ready } from "@devowl-wp/react-utils";
import { handleCorruptRestApi } from "@devowl-wp/utils";
import { Provider } from "./components/common/provider.js";
import { OptionsPage } from "./components/options/optionsPage.js";
import { RootStore } from "./store/rootStore.js";
import { request } from "./utils/request.js";
handleCorruptRestApi({
    [RootStore.get.optionStore.restNamespace]: async ()=>{
        await request({
            location: {
                path: "/plugin"
            }
        });
    }
});
const node = document.getElementById(`${RootStore.get.optionStore.slug}-component`);
ready(()=>{
    if (node) {
        createRoot(node).render(/*#__PURE__*/ _jsx(Provider, {
            children: /*#__PURE__*/ _jsx(OptionsPage, {})
        }));
    }
});
$("link#dark_mode-css").length && $("body").addClass("aiot-wp-dark-mode");
// Expose this functionalities to add-ons, but you need to activate the library functionality
// in your webpack configuration, see also https://webpack.js.org/guides/author-libraries/
export * from "@devowl-wp/utils";
export * from "./wp-api/index.js";
export * from "./store/index.js";
